<template>
    <div class="ob1-tooltip">
        <button type="button" class="ob1-tooltip-trigger ob1-link-icon ob1-link-icon-small" :aria-describedby="id">
            <span class="icon icon-info-alt" aria-hidden="true" />
            <span class="ob1-link-icon-text">DAS</span>
        </button>
        <div class="ob1-tooltip-content ob1-tooltip-top">
            <p
                :id="id"
                role="tooltip"
                class="sr-only"
                v-html="accessibilityMessage"
            />
            <div v-if="das.head" aria-hidden="true" v-html="das.head" />
            <div
                v-if="das.trunk"
                aria-hidden="true"
                v-html="das.trunk"
            />
            <div
                v-if="das.member"
                aria-hidden="true"
                v-html="das.member"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        },
        das: {
            type: Object,
            required: true
        }
    },
    computed: {
        accessibilityMessage() {
            return this.das.headAccessibility + ' ' + this.das.trunkAccessibility + ' ' + this.das.memberAccessibility
        }
    },
    methods: {}
}
</script>

<style lang="scss">
@import 'ob1_common';
//tooltip pour le das c une surcharge à supprimer une fois le tooltip crée sur ob1
.ob1-tooltip {
    display: inline-flex;

    .ob1-tooltip-content {
        display: none;
    }
}

.ob1-tooltip:hover {
    .ob1-tooltip-content {
        font-size: px-to-rem(14);
        position: absolute;
        z-index: 107;
        box-sizing: border-box;
        width: max-content;
        max-width: px-to-rem(380);
        padding: px-to-rem(15);
        box-shadow: 0 0 5px 0 #aaa;

        //add arrow to desktop tooltip
        &::after {
            position: absolute;
            display: initial;
            margin-left: -10px;
            content: "";
            border: 8px solid #000;
            border-color: transparent transparent #fff #fff;
            box-shadow: -3px 3px 3px 0 rgba(0, 0, 0, .15);
            transform-origin: -1px 0;
        }
    }

    .ob1-tooltip-content.ob1-tooltip-top {
        top: auto;
        right: auto;
        bottom: 100%;
        left: 1px;
        transform: translateY(-6%);

        &::after {
            top: 100%;
            left: 22px;
            transform: rotate(-45deg);
        }
    }

}

.ob1-tooltip-trigger:focus-visible + .ob1-tooltip-content.ob1-tooltip-top {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
}

.ob1-tooltip-trigger:focus-visible +
.ob1-tooltip-content {
    font-size: px-to-rem(14);
    position: absolute;
    z-index: 107;
    box-sizing: border-box;
    width: max-content;
    max-width: px-to-rem(380);
    padding: px-to-rem(15);
    box-shadow: 0 0 5px 0 #aaa;

    //add arrow to desktop tooltip
    &::after {
        position: absolute;
        display: initial;
        margin-left: -10px;
        content: "";
        border: 7px solid #000;
        border-color: transparent transparent #fff #fff;
        box-shadow: -3px 3px 3px 0 rgba(0, 0, 0, .15);
        transform-origin: -1px 0;
    }

    .ob1-tooltip-content.ob1-tooltip-top {
        bottom: 100%;
        left: 1px;
        transform: translateY(-6%);

        &::after {
            top: 100%;
            left: 22px;
            transform: rotate(-45deg);
        }
    }
}

.ob1-tooltip-trigger:focus-visible + .ob1-tooltip-content.ob1-tooltip-top {
    bottom: 100%;
    left: 1px;
    transform: translateY(-6%);

    &::after {
        top: 100%;
        left: 22px;
        transform: rotate(-45deg);
    }
}

</style>
